<section class="card-text-editor" aria-labelledby="card-text-title">
  <div class="card-text-heading">
    <div>
      <h3 id="card-text-title">Product card texts</h3>
      <p>Change the wording of product card texts for this chatbot. Leave a field empty to use the default text.</p>
    </div>
    <span class="override-count">{{ changedCount }} overridden</span>
  </div>
  <p class="text-language">Language: <strong>{{ localeLabel || locale }}</strong>. Follows Default locale in Localization.</p>
  <div class="column-headings" aria-hidden="true"><span>Default text</span><span>My text</span></div>
  @for (field of buttonFields; track field.key) {
    <div class="text-row" [attr.data-text-key]="field.key">
      <div class="default-text"><span class="field-context">{{ field.title }}</span><strong>{{ defaults[field.key] ?? 'Loading default…' }}</strong></div>
      <div class="override-input">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ field.title }}</mat-label>
          <input matInput [disabled]="control.disabled" [value]="value(field.key)" (input)="change(field.key, $event)" maxlength="40" placeholder="Use default text" [attr.data-text-input]="field.key">
          <mat-hint align="end">{{ value(field.key).length }}/40</mat-hint>
        </mat-form-field>
        <button mat-button type="button" [disabled]="control.disabled || !value(field.key)" (click)="setText(field.key, '')" [attr.aria-label]="'Use default: ' + field.title">Use default</button>
      </div>
    </div>
  }
  <button mat-button type="button" class="other-toggle" (click)="showOther = !showOther" [attr.aria-expanded]="showOther" aria-controls="other-card-texts">
    {{ showOther ? 'Hide other texts' : 'Other texts' }} ({{ otherFields.length }})
  </button>
  @if (showOther) {
    <div id="other-card-texts">
      @for (field of otherFields; track field.key) {
        <div class="text-row" [attr.data-text-key]="field.key">
          <div class="default-text"><span class="field-context">{{ field.title }}</span><strong>{{ defaults[field.key] ?? 'Loading default…' }}</strong></div>
          <div class="override-input">
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ field.title }}</mat-label>
              <input matInput [disabled]="control.disabled" [value]="value(field.key)" (input)="change(field.key, $event)" maxlength="40" placeholder="Use default text" [attr.data-text-input]="field.key">
              <mat-hint align="end">{{ value(field.key).length }}/40</mat-hint>
            </mat-form-field>
            <button mat-button type="button" [disabled]="control.disabled || !value(field.key)" (click)="setText(field.key, '')" [attr.aria-label]="'Use default: ' + field.title">Use default</button>
          </div>
        </div>
      }
    </div>
  }
  @if (control.invalid) {
    <p class="text-error" role="alert">Use plain text of at most 40 characters without line breaks.</p>
  }
</section>
